import { render, staticRenderFns } from "./company-invite.vue?vue&type=template&id=09980f56&"
import script from "./company-invite.vue?vue&type=script&lang=js&"
export * from "./company-invite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports